import styled from "styled-components"

// THIS MIMICS THE COMMERCE CONTAINER FOR STORYBOOK
export const CommerceStoryWrapper = styled.div`
  height: 700px;
  outline: 1px solid #eeebeb;
  background-color: white;
  margin: 10px auto;
  overflow: hidden;
  padding: 0;
  margin: 0 auto;
`

// Outer wrapper div for Product/Cart/Checkout pages,
// which contains within it position: absolute headers and footers.
export const OuterWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

// Scroll wrapper for inner section of Product and Checkout pages, between header and footer.
export const ScrollWrapper = styled.div`
  padding: 10px 20px;
  overflow-y: auto;
  background-color: white;
  width: 100%;
  flex-grow: 1;
`
